// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__B0hE7","body":"Dashboard_body__6xvaz","active":"Dashboard_active__rPGU6","content":"Dashboard_content__mZH+6"};